var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: { cols: "12" },
          scopedSlots: _vm._u([
            {
              key: "no-data",
              fn: function () {
                return [
                  _c(
                    "v-row",
                    { staticClass: "my-16", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [_c("no-data")],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("v-data-table", {
            staticClass: "logs-table",
            attrs: {
              id: "api-logs-grid",
              headers: _vm.headers,
              items: _vm.pageData,
              "hide-default-footer": true,
              "items-per-page": 50,
              expanded: _vm.expandedItems,
              "item-key": _vm.id,
              "single-expand": false,
              "show-expand": false,
            },
            on: {
              "update:expanded": function ($event) {
                _vm.expandedItems = $event
              },
              "click:row": _vm.toggleExpand,
            },
            scopedSlots: _vm._u([
              {
                key: "item.type",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-chip",
                      {
                        staticClass: "type-badge",
                        class: _vm.getStatusClass(item.type),
                        attrs: { small: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.type) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "item.message",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("div", { staticClass: "message-content" }, [
                      _vm.isJsonString(item.message)
                        ? _c("div", { staticClass: "json-preview" }, [
                            _c(
                              "div",
                              { staticClass: "message-header" },
                              [
                                _vm.isRequestMessage(item.message)
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "request-badge mr-2",
                                        attrs: {
                                          small: "",
                                          color: "primary",
                                          "text-color": "white",
                                        },
                                      },
                                      [_vm._v(" Request ")]
                                    )
                                  : _vm.isResponseMessage(item.message)
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "response-badge mr-2",
                                        attrs: {
                                          small: "",
                                          color: "success",
                                          "text-color": "white",
                                        },
                                      },
                                      [_vm._v(" Response ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "span",
                                  { staticClass: "json-placeholder" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-code-json")]
                                    ),
                                    _vm._v(" JSON data (click to view) "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.formatMessage(item.message))),
                          ]),
                    ]),
                  ]
                },
              },
              {
                key: "item.createdDateTime",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("span", { staticClass: "timestamp" }, [
                      _vm._v(_vm._s(_vm.formatTimestamp(item.createdDateTime))),
                    ]),
                  ]
                },
              },
              {
                key: "item.traceId",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-chip",
                      {
                        staticClass: "trace-id-badge",
                        style: {
                          backgroundColor: _vm.getTraceIdColor(item.traceId),
                        },
                        attrs: { small: "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.copyToClipboard(item.traceId)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.traceId) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "expanded-item",
                fn: function (ref) {
                  var item = ref.item
                  var headers = ref.headers
                  return [
                    _c(
                      "td",
                      {
                        staticClass: "pa-0",
                        attrs: { colspan: headers.length },
                      },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-4 expanded-log-details",
                            attrs: { flat: "" },
                          },
                          [
                            _c(
                              "v-row",
                              { staticClass: "ma-0" },
                              [
                                item.browser
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "pa-0 pr-4",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _c("h4", [_vm._v("Browser")]),
                                        _c(
                                          "div",
                                          { staticClass: "browser-info" },
                                          [_vm._v(_vm._s(item.browser))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "pa-0",
                                    attrs: { cols: item.browser ? 10 : 12 },
                                  },
                                  [
                                    _c("h4", [_vm._v("Message")]),
                                    _c("pre", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatJsonHtml(item.message)
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToClipboard(
                                            item.message
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                            item.request
                              ? [
                                  _c("h4", { staticClass: "mt-4" }, [
                                    _vm._v("Request"),
                                  ]),
                                  _c("pre", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.syntaxHighlightJson(
                                          _vm.formatJson(item.request)
                                        )
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(item.request)
                                      },
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            item.response
                              ? [
                                  _c("h4", { staticClass: "mt-4" }, [
                                    _vm._v("Response"),
                                  ]),
                                  _c("pre", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.syntaxHighlightJson(
                                          _vm.formatJson(item.response)
                                        )
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          item.response
                                        )
                                      },
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }